import React from 'react'
import styled from 'styled-components'

const Box = styled.div`
  width: 320px;
  height: 100px;
  border-radius: 10px;
  border: 1px solid ${props => props.isCompleted ? '#5DB594' : '#BFBFBF'};
  padding: 9px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: ${props => {
    if (props.isCompleted) return '#ECFFF8';
    if (props.isVisited) return '#FFEDE2';
    return '#f6f6f6';
  }};
  cursor: pointer;
  position: relative;
`

const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: center;
`

const AssessmentNumber = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${props => props.isCompleted ? '#5DB594' : props.isActive ? '#000000' : '#B8B8B8'};
  text-align: center;
`

const TypeText = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${props => props.isCompleted ? '#5DB594' : props.isActive ? '#000000' : '#B8B8B8'};
  text-align: center;
`

const CheckmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9" fill="#5DB594" fillOpacity="0.2" stroke="#5DB594" strokeWidth="2"/>
    <path d="M6 10L9 13L14 7" stroke="#5DB594" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const QuestionTypeBox = ({ type, isActive, index, onClick, isCompleted, isVisited }) => {
  return (
    <Box 
      isActive={isActive} 
      onClick={onClick} 
      isCompleted={isCompleted}
      isVisited={isVisited && !isCompleted}
    >
      <SectionRow>
        {isCompleted && <CheckmarkIcon />}
        <AssessmentNumber isActive={isActive} isCompleted={isCompleted}>Section - {index + 1}</AssessmentNumber>
      </SectionRow>
      <TypeText isActive={isActive} isCompleted={isCompleted}>{type}</TypeText>
    </Box>
  )
}

export default QuestionTypeBox 